import React, { useState } from 'react'
import NavigationBar from '../../components/Navigationbar/Navigationbar'
import { Box, Tab, tabClasses, Table, TabList, TabPanel, Tabs } from '@mui/joy'
import Headline from '../../components/headline/Headline';
import PointsKontoOverview from './components/PointsKontoOverview';
import OverviewPoints from './components/OverviewPoints';

function PunkteKonto() {
  const [wit, setWit] = useState("90.5%");
  return (
    <>
      <Box
        sx={{
          width: wit,
          position: "fixed",
          top: 0,
          right: 0,
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          bgcolor: "background.body",
          borderLeft: "1px solid",
          borderColor: "divider",
          overflowY: "auto",
        }}
      >
        <Headline title={"Punktekonto"} />
        <Tabs sx={{ width: "100%" }} defaultValue={0}>
          <TabList
            sx={{
              pt: 1,
              justifyContent: 'center',
              [`&& .${tabClasses.root}`]: {
                flex: 'initial',
                bgcolor: 'transparent',
                '&:hover': {
                  bgcolor: 'transparent',
                },
                [`&.${tabClasses.selected}`]: {
                  color: 'primary.plainColor',
                  '&::after': {
                    height: 2,
                    borderTopLeftRadius: 3,
                    borderTopRightRadius: 3,
                    bgcolor: 'primary.500',
                  },
                },
              },
            }}
          >
            <Tab variant="soft" color="neutral">Nutzer</Tab>
            <Tab variant="soft" color="neutral">Übersicht</Tab>
          </TabList>
            <TabPanel value={0}>
              <PointsKontoOverview/>
            </TabPanel>
            <TabPanel value={1}>
              <OverviewPoints/>
            </TabPanel>



          </Tabs>



      </Box>


      <NavigationBar state={"home"} back={false} />
    </>
  )
}

export default PunkteKonto
